import { MessageEvent } from 'reconnectingwebsocket';
import { beachReducer, TickerStore } from '../';
import { FetchBeachTickerResponsePayload } from '../../../shared/beach/events'
import {
  LoadBeachTickerStatePayload,
  loadTickerStateFailure,
  loadBeachTickerStateSuccess,
  matchUpdate,
  mapBeachTickerMatchDay,
  mapBeachTickerMatchSeries
} from './reducer';
import { getToday } from '../utils';
import { setActiveFilter } from '../day-filter/reducer';
import { config } from '../config/config';
import { ServerSocketEvent } from '../../../shared/socket/events';
import {
  BeachTickerMatchState
} from '../../../shared/beach/ticker';
import { buildSocketClient } from '../socket';
import { TickerType } from '../models';

export const connectToBeachTicker = async (tickerId: string, store: TickerStore) => {

  const onFetchBeachTickerResponse = (payload: FetchBeachTickerResponsePayload | null, tickerId: string) => {

    if (payload === null) {
      return store.dispatch(loadTickerStateFailure('No ticker data received for ticker instance: ' + tickerId))
    }

    const state: LoadBeachTickerStatePayload = {
      matchDays: payload.matchDays.map(m => mapBeachTickerMatchDay(m, payload.matchSeries)),
      matchSeries: mapBeachTickerMatchSeries(payload.associations, payload.matchSeries),
      matchStates: payload.matchStates,
      settings: payload.settings,
      associations: payload.associations,
      hierarchies: payload.hierarchies
    }
    const rootState: ReturnType<typeof beachReducer> = store.getState() as any
    if (rootState.dayFilter.activeFilterDay === null) {
      const today = getToday()
      const todayIdx = payload.matchDays.findIndex(m =>
        new Date(m.date).toLocaleDateString() === today.toLocaleDateString())
      store.dispatch(setActiveFilter(todayIdx))
    }
    return store.dispatch(loadBeachTickerStateSuccess(state))
  }

  try {
    const res = await fetch(`${config.httpEndpoint}/live/beach/tickers/${tickerId}`)
    if (res.ok) {
      const payload: FetchBeachTickerResponsePayload = await res.json()
      onFetchBeachTickerResponse(payload, tickerId)
    } else {
      onFetchBeachTickerResponse(null, tickerId)
    }
  } catch(error) {
    onFetchBeachTickerResponse(null, tickerId)
  }

  const client = await buildSocketClient(tickerId, store, TickerType.BEACH)

  const onMessage = (msg: MessageEvent) => {

    try {

      const event: ServerSocketEvent = JSON.parse(msg.data)

      switch (event.type) {
        case 'FETCH_DATA_RESPONSE_ERROR':
          const msg = event.payload.type === 'NOT_FOUND'
            ? `Es konnte kein Ticker mit der id ${tickerId} gefunden werden.`
            : `Bitte überprüfen Sie die tickerId: ${tickerId}`
          client.close()
          return store.dispatch(loadTickerStateFailure(msg))

        case 'MATCH_UPDATE':
          try {
            const matchstate = event.payload as BeachTickerMatchState
            return store.dispatch(matchUpdate(matchstate))
          } catch (error) {
            return
          }

        default:
          return null

      }

    } catch (err) {
      return store.dispatch(loadTickerStateFailure('Failed parsing ticker data for ticker instance: ' + tickerId))
    }
  }

  client.onmessage = onMessage

}
